import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4 py-16 bg-grain">
      <Card className="max-w-lg w-full p-8 text-center">
        <div className="h-14 w-14 mx-auto rounded-full bg-amber-100 dark:bg-amber-950/60 flex items-center justify-center">
          <XCircle className="h-7 w-7 text-amber-600 dark:text-amber-400" />
        </div>
        <h1 className="mt-5 font-heading text-3xl font-bold" data-testid="payment-cancel-heading">
          Checkout cancelled
        </h1>
        <p className="text-muted-foreground mt-2">
          No worries — you weren't charged. Pick another time and book whenever you're ready.
        </p>
        <div className="mt-6 flex gap-3 justify-center">
          <Button asChild variant="outline" className="rounded-full">
            <Link to="/">Back home</Link>
          </Button>
          <Button asChild className="rounded-full">
            <Link to="/tutors">Browse tutors</Link>
          </Button>
        </div>
      </Card>
    </div>
  );
}
